// PageInvoiceTemplateView Component
/* eslint indent: 0 */

import React from 'react'
import HTML5Backend from 'react-dnd-html5-backend'
import { DragDropContext as dragDropContext } from 'react-dnd'
import _ from 'lodash'
import async from 'async'

import app from '../../../app.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import IntlUtil from '../../../lib/intlutil.jsx'
import eventfilters from '../../../lib/eventfilters.jsx'
import util from '../../../lib/util.jsx'
import currency from '../../../lib/currency.jsx'

import BaseInvoiceView from '../../page/base_invoiceview/base_invoiceview.jsx'
import PurchaseOrderAddItem from '../../../expense/purchaseorder/purchaseorder_additem/purchaseorder_additem.jsx'
import PurchaseOrderViewIntro from '../../../expense/purchaseorder/purchaseorder_viewintro/purchaseorder_viewintro.jsx'
import InvoiceViewContent from '../../invoice/invoice_viewcontent/invoice_viewcontent.jsx'
import DialogEditInvoice from '../../../invoice/dialog/dialog_editinvoice/dialog_editinvoice.jsx'
import DialogInvoiceAddress from '../../../invoice/dialog/dialog_invoice_address/dialog_invoice_address.jsx'
import DialogInvoiceTemplate from '../../dialog/dialog_invoicetemplate/dialog_invoicetemplate.jsx'
import DialogTemplateMailSetting from '../../../invoice/dialog/dialog_templatemailsetting/dialog_templatemailsetting.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import calculate from '../../../lib/calculate.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import TermsAndConditionText from '../../../common/form/terms_and_conditions/terms_and_conditions.jsx'
import { getTermsAndConditions } from '../../../lib/pdfTemplateUtils'
import { InvoicesIcon } from '../../../common/layout/menu_icons/invoices.jsx'

@dragDropContext(HTML5Backend)
class PageInvoiceTemplateView extends BaseInvoiceView {
  constructor (props) {
    super(props, 'invoice-template-view', 'invoices', 'invoice-template-view')

    this.state = {
      dataDate: null
    }

    this.data = {
      invoice: null,
      budget: null,
      items: null,
      projectUsers: [],
      emailSuggestions: [],
      taxRateVatOptions: [],
      quickbookItems: []
    }

    this.invoiceItem = ''

    this._setFABButtonState(true, true)
    this._initRealTimeVariables()
    this._references = {
      refdialogMailSetting: React.createRef(),
      dialogInvoiceTemplate: React.createRef(),
      invoiceViewContent: React.createRef(),
      refDialogInvoiceAddress: React.createRef(),
      invoiceItemAdd: React.createRef(),
      invoiceIntro: React.createRef()
    }

    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
    this._initEvents()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (
      nextProps.invoiceTemplateId &&
      this.props.invoiceTemplateId !== nextProps.invoiceTemplateId
    ) {
      this._getData()
    }
  }

  renderContent () {
    const _className = 'pageinnercont'
    const profile =
      app.getTeam() && app.getTeam().profile ? app.getTeam().profile : null

    return (
      <div className={_className}>
        <PurchaseOrderViewIntro
          ref={this._references.invoiceIntro}
          purchaseOrder={this.data.invoice}
          onChange={this._onIntroChange.bind(this)}
          onDelete={this._onDeleteIntro.bind(this)}
        />
        {this.data.invoice && this.data.budget && (
          <InvoiceViewContent
            ref={this._references.invoiceViewContent}
            invoice={this.data.invoice}
            isQuickbookConnected={app.isQuickbookConnected()}
            quickbookItems={this.data.quickbookItems}
            budget={InvoiceUtil.getRenderObject(
              this.data.budget,
              this.data.items
            )}
            onChange={this._onChangeBudget.bind(this)}
            onUpdateInvoiceTotal={this._onUpdateInvoiceTotal.bind(this)}
            onItemCreate={this._onItemCreate.bind(this)}
            onItemUpdate={this._onItemUpdate.bind(this)}
            hasPageBreakTop={this.data.invoice.hasPageBreakTop}
            onItemRemove={this._onClickItemRemove.bind(this)}
            onPhaseRemove={this._onPhaseRemove.bind(this)}
            projectUsers={this.data.projectUsers}
            vatRate={
              profile && profile.vatRate ? parseFloat(profile.vatRate) : 0
            }
            teamCountry={profile ? profile.country : ''}
            taxRateVatOptions={this.data.taxRateVatOptions}
            onUpdateInfo={this._onUpdateInvoiceInfo.bind(this)}
            createNewActivity={this._onCreateNewActivity.bind(this)}
            onUpdateInvoiceType={this._onUpdateInvoiceType.bind(this)}
            onCreateTaxRate={this._onCreateTaxRate.bind(this)}
            reloadQuickbookItems={this._reloadQuickbookItems.bind(this)}
          />
        )}
        {this._renderTermsAndCondition()}
        {this._renderAddItem()}
        <DialogEditInvoice
          onSubmit={this._onSubmitInvoiceEdit.bind(this)}
          onDelete={this._onDeleteInvoice.bind(this)}
        />
        <DialogInvoiceAddress
          ref={this._references.refDialogInvoiceAddress}
          message='invoice.form.finalizeAddrTitleInfo'
          teamCountry={app.teamCountry}
          onSubmit={this._onSubmitAddressInvoice.bind(this)}
        />
        <DialogInvoiceTemplate
          ref={this._references.dialogInvoiceTemplate}
          getProjects={InvoiceUtil.getProjects}
          contactSearch={this._onSearchContact.bind(this)}
          onSubmit={this._updateTemplateInvoice.bind(this)}
          onDelete={this._onDelete.bind(this)}
        />
        <DialogTemplateMailSetting
          ref={this._references.refdialogMailSetting}
          isQuickbookConnected={app.isQuickbookConnected()}
          onSubmit={this._onSubmitMail.bind(this)}
          showWithoutContext
          mailSuggestions={this.data.emailSuggestions}
          showMultiAttachments
        />
      </div>
    )
  }

  _onUpdateInvoiceInfo (updateObj, callback) {
    if (!this.data.invoice.id) {
      return
    }

    const saveObj = _.cloneDeep(updateObj)
    if (updateObj.budget) {
      saveObj.budget = InvoiceUtil.getSaveObject(saveObj.budget).budget
    }

    if (Object.keys(saveObj).length > 0) {
      app
        .service('/api/invoice/template')
        .patch(this.data.invoice.id, saveObj)
        .then(_introRes => {
          if (callback) {
            callback(null)
          }
        })
        .catch(introErr => {
          app.debug(
            'PageInvoiceTemplateView: _onUpdateInvoiceInfo err',
            introErr
          )
        })
    }
  }

  _onUpdateInvoiceType (type) {
    const updateObj = { phaseType: type }
    this._onUpdateInvoiceInfo(updateObj, null)
  }

  async _onAddTermsAndCondition () {
    if (!this.data.invoice.termsAndCondition) {
      this.data.invoice.termsAndCondition = await getTermsAndConditions(app.getTeamId(), 'invoice')
      this.data.showTermsAndCondition = true

      this.setState({ dataDate: new Date() })

      // Update terms and conditions
      if (this.data.invoice.termsAndCondition) {
        const updateObj = {
          termsAndCondition: this.data.invoice.termsAndCondition
        }

        this._onUpdateInvoiceInfo(updateObj)
      }
    }
  }

  _renderTermsAndCondition () {
    const { showTermsAndCondition, invoice } = this.data
    if (!showTermsAndCondition) {
      return null
    }
    return <TermsAndConditionText
      text={invoice.termsAndCondition}
      onChange={this.handleOnChangeTermsAndConditon}
      onBlur={this.handleOnBlurTermsAndConditon}
      onDelete={this.handleOnDeleteTermsAndCondition}
           />
  }

  handleOnChangeTermsAndConditon = value => {
    this.data.invoice.termsAndCondition = value
    this.setState({ dataDate: new Date() })
  }

  handleOnBlurTermsAndConditon = () => {
    const updateObj = {
      termsAndCondition: this.data.invoice.termsAndCondition
    }

    this._onUpdateInvoiceInfo(updateObj)
  }

  handleOnDeleteTermsAndCondition = () => {
    this._onUpdateInvoiceInfo({ termsAndCondition: '' }, () => {
      this.data.invoice.termsAndCondition = ''
      this.data.showTermsAndCondition = false

      this.setState({ dataDate: new Date() })
    })
  }

  _onCreateTaxRate (rateObj) {
    const address = this.data.invoice.contactAddress
    if (address && address.state) {
      this.data.taxRateVatOptions.push(rateObj)
      this.setState({ dataDate: new Date() })

      app
        .service('/api/taxrate/create')
        .create({
          state: address.state,
          rate: rateObj
        })
        .catch(err => {
          app.debug('PageInvoiceView: _onCreateTaxRate Error', err)
        })
    }
  }

  /* Event handlers */
  _onMailSetting () {
    this._showEmailDialog(false)
  }

  _showEmailDialog (bShowErr) {
    const invoicetemplate = _.cloneDeep(this.data.invoice)
    const contact = invoicetemplate.contact
    const contactAddresses =
      invoicetemplate &&
      invoicetemplate.contact &&
      invoicetemplate.contact.addresses
        ? invoicetemplate.contact.addresses
        : null

    invoicetemplate.contactPersonOptions = this._getContactPersonOptions(
      contact
    )
    invoicetemplate.addressOptions = this._getContactAddressOptions(
      invoicetemplate
    )
    invoicetemplate.addresses = contactAddresses
    invoicetemplate.contactAddress =
      invoicetemplate.contactAddress && invoicetemplate.contactAddress.type
        ? invoicetemplate.contactAddress
        : contactAddresses
        ? contactAddresses[0]
        : null
    if (this._references.refdialogMailSetting.current) {
      this._references.refdialogMailSetting.current.show(
        invoicetemplate,
        bShowErr
      )
    }
  }

  _getContactPersonOptions (contact) {
    const contactPersonOptions = []
    if (
      contact &&
      contact.contactPersons &&
      contact.contactPersons.length > 0
    ) {
      contact.contactPersons.map(contactPerson => {
        if (contactPerson.email) {
          const label =
            contactPerson.name +
            (contactPerson.email ? ' - ' + contactPerson.email : '')
          contactPersonOptions.push({
            label: label,
            value: label,
            obj: contactPerson
          })
        }
      })
    }

    return contactPersonOptions
  }

  _getContactAddressOptions (invoiceTemplate) {
    const addressOptions = []
    const contact = invoiceTemplate.contact
    if (contact && contact.addresses && contact.addresses.length > 0) {
      contact.addresses.map(address => {
        const existTypeOption = _.find(
          addressOptions,
          addressOption => addressOption.label === address.type
        )
        const label = IntlUtil.convertMessage(
          `contact.view.type${address.type}`
        )
        if (existTypeOption === undefined) {
          addressOptions.push({
            label: label,
            value: address.type.toLowerCase()
          })
        }
      })
    }

    if (
      invoiceTemplate.contactAddress &&
      addressOptions[0].value === undefined
    ) {
      const label = IntlUtil.convertMessage(
        `contact.view.type${invoiceTemplate.contactAddress.type}`
      )
      addressOptions.push({
        label: label,
        value: invoiceTemplate.contactAddress.type.toLowerCase()
      })
    }

    return addressOptions
  }

  _onSearchContact (keyword, callback) {
    this._onCommonFilterContactSearch(keyword, callback)
  }

  _onSearchProject (keyword, callback) {
    this._onCommonFilterProjectSearch(keyword, false, callback)
  }

  _updateTemplateInvoice (templateObj, templateId) {
    if (templateObj.startDate) {
      templateObj.startDate = DateUtil.convertDatetoUTCStartDate(
        templateObj.startDate
      )
    }

    if (templateObj.endDate) {
      templateObj.endDate = DateUtil.convertDatetoUTCStartDate(
        templateObj.endDate
      )
    }

    app
      .service('/api/invoice/template')
      .patch(templateId, templateObj)
      .then(_templateObj => {
        if (this._references.dialogInvoiceTemplate.current) {
          this._references.dialogInvoiceTemplate.current.hide()
        }
      })
      .catch(templateErr => {
        app.debug(
          'PageInvoiceTemplate: _updateTemplateInvoice Error',
          templateErr
        )
        this.showError('invoicetemplate.list.msgErrorUpdateTemplateObj')
      })
  }

  _onDelete (invoiceTemplateId) {
    if (!invoiceTemplateId) {
      return false
    }

    app
      .service('/api/invoice/template')
      .remove(invoiceTemplateId)
      .then(_deleteRes => {
        if (this._references.dialogInvoiceTemplate.current) {
          this._references.dialogInvoiceTemplate.current.hide()
        }
        app.changePage('invoice-template')
      })
      .catch(deleteErr => {
        app.debug('PageInvoiceTemplateView delete err', deleteErr)
      })
  }

  _onStart () {
    const invoice = this.data.invoice
    let noErrors = 0

    if (this._validateStartDate(invoice.startDate)) {
      if (this._references.dialogInvoiceTemplate.current) {
        this._references.dialogInvoiceTemplate.current.show(invoice, true)
      }

      noErrors++
    } else if (
      (invoice.mailSetting === null ||
        invoice.mailSetting.toEmails === undefined ||
        invoice.mailSetting.toEmails.length === 0) &&
      invoice.autoMail &&
      !app.isQuickbookConnected()
    ) {
      this._showEmailDialog(true)
      noErrors++
    }

    if (noErrors === 0) {
      app
        .service('/api/invoice/template')
        .patch(invoice.id, { isActive: true })
        .then(_updateRes => {})
        .catch(updateErr => {
          app.debug('PageInvoiceTemplateView: _onStart err', updateErr)
        })
    }
  }

  _validateStartDate (startDate) {
    const currDate = new Date()
    const dueDateTimeStamp = new Date(startDate).getTime()
    const invoiceDateTimeStamp = new Date(currDate).getTime()

    if (util.isDateEqual(new Date(startDate), new Date(currDate))) {
      return false
    }

    if (dueDateTimeStamp < invoiceDateTimeStamp) {
      return true
    }

    return false
  }

  _onEditTemplate (invoiceTemplate, ev) {
    ev.preventDefault()
    if (
      invoiceTemplate &&
      invoiceTemplate.id &&
      this._references.dialogInvoiceTemplate.current
    ) {
      this._references.dialogInvoiceTemplate.current.show(
        invoiceTemplate,
        false
      )
    }
  }

  _onComplete () {
    const invoice = this.data.invoice

    app
      .service('/api/invoice/template')
      .patch(invoice.id, { isCanceled: true })
      .then(_updateRes => {})
      .catch(updateErr => {
        app.debug('PageInvoiceTemplateView: _onComplete err', updateErr)
      })
  }

  _onIntroChange (introText) {
    this.onIntroChange('/api/invoice/template', introText)
  }

  _onDeleteIntro () {
    if (this.data.invoice !== null) {
      this.data.invoice.introText = null
      this._onIntroChange(null)

      this.setState({ dataDate: new Date() })
    }

    if (this._references.invoiceIntro.current) {
      this._references.invoiceIntro.current.hide()
    }
  }

  _onItemCreate (item) {
    const createObj = InvoiceUtil.getNewItemObject(item)
    delete createObj.id

    createObj.invoiceTemplateId = this.props.invoiceTemplateId

    app
      .service('/api/invoice/template/item')
      .create(createObj)
      .then(createItemRes => {
        if (createItemRes) {
          item.id = createItemRes.id
        }
      })
      .catch(createItemErr => {
        app.debug('PageInvoiceTemplateView: _onItemCreate err', createItemErr)
      })
  }

  _onItemUpdate (item, attribute, callback) {
    if (!item.id) {
      return false
    }

    const updateObj = InvoiceUtil.getUpdateItemObject(item, attribute)
    app
      .service('/api/invoice/template/item')
      .patch(item.id, updateObj)
      .then(_updItemRes => {
        if (callback) {
          callback(null)
        }
      })
      .catch(updItemErr => {
        app.debug('PageInvoiceTemplateView: _onItemUpdate err', updItemErr)
        if (callback) {
          callback(updItemErr)
        }
      })

    return ''
  }

  _onClickItemRemove (item) {
    this._onItemRemove(item, null)
  }

  _onPhaseRemove (phaseId, removeData, callback) {
    removeData.type = 'invoicetemplate'

    app
      .service('/api/common/removephase')
      .create(removeData)
      .then(_res => {
        callback(null)
      })
      .catch(removeErr => {
        app.debug('PageProjectViewBudget: _onPhaseRemove err', removeErr)
      })
  }

  _onItemRemove (item, callback) {
    if (!item.id) {
      return false
    }

    app
      .service('/api/invoice/template/item')
      .remove(item.id)
      .then(_remItemRes => {
        if (this.invoiceItem) {
          if (this._references.invoiceViewContent.current) {
            this._references.invoiceViewContent.current.reloadItem(
              this.invoiceItem
            )
          }
          this.invoiceItem = ''
        }

        if (callback) {
          callback()
        }
      })
      .catch(remItemErr => {
        app.debug('PageInvoiceTemplateView: _onItemRemove err', remItemErr)
        this.invoiceItem = ''
      })

    return ''
  }

  _onUpdateInvoiceTotal (total, totalInc) {
    this.onUpdateInvoiceTotal('/api/invoice/template', total, totalInc)
  }

  _onChangeBudget (budgetObj) {
    this.onChangeBudget('/api/invoice/template', budgetObj)
  }

  _saveInvoiceItems (invoiceTemplateId, items, callback) {
    const invoiceTemplateItemService = app.service('/api/invoice/template/item')

    async.map(
      items,
      (item, mapDone) => {
        const updateId = item.id

        const updateItem = _.cloneDeep(item)
        delete updateItem.id

        if (updateId) {
          invoiceTemplateItemService
            .patch(updateId, updateItem)
            .then(_updItemRes => {
              mapDone(null)
            })
            .catch(updItemErr => {
              mapDone(updItemErr)
              app.debug(
                'PageInvoiceTemplateView: _saveInvoiceItems err',
                updItemErr
              )
            })
        }
      },
      (asyncErr, _asyncRes) => {
        if (asyncErr) {
          callback(asyncErr)
        } else {
          callback(null)
        }
      }
    )
  }

  _getData () {
    this._setDataLoading()

    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataBudget(done)
        },
        done => {
          this._getDataProjectUsers(done)
        },
        done => {
          const team = app.getTeam()
          const teamCountry = team && team.profile ? team.profile.country : ''
          if (teamCountry === 'US') {
            this._getVatSelectOptions(done)
          } else {
            done(null)
          }
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataBudget (callback) {
    async.series(
      [
        done => {
          this._getDataInvoice(done)
        },
        done => {
          this._getDataInvoiceItems(done)
        },
        done => {
          this._getQuickbookItems(done)
        }
      ],
      (_err, _res) => {
        callback(null)
      }
    )
  }

  _getQuickbookItems (callback) {
    app
      .service('/api/quickbook/item')
      .find({})
      .then(quickbookRes => {
        if (quickbookRes) {
          this.data.quickbookItems = quickbookRes.data
        }

        callback(null)
      })
      .catch(quickbookErr => {
        app.debug(
          'PageInvoiceTemplateView: _getQuickbookItems err',
          quickbookErr
        )
        callback(quickbookErr)
      })
  }

  _getDataInvoice (callback) {
    const params = {
      query: {
        $client: {
          subObjects: {
            contact: [
              'company',
              'addresses',
              'vatNo',
              'paymentDays',
              'contactPersons'
            ],
            project: ['title', 'budget'],
            items: []
          }
        }
      }
    }

    app
      .service('/api/invoice/template')
      .get(this.props.invoiceTemplateId, params)
      .then(invoiceRes => {
        if (invoiceRes) {
          this.data.invoice = invoiceRes
          this.data.invoice.status = 'Draft'
          this.data.invoice.vats = []
          this.data.showTermsAndCondition = !!invoiceRes.termsAndCondition
        }
        callback(null)
      })
      .catch(invoiceErr => {
        app.debug('PageInvoiceTemplateView: _getDataInvoice err', invoiceErr)
        callback(invoiceErr)
      })
  }

  _getDataInvoiceItems (callback) {
    const params = {
      query: {
        invoiceTemplateId: this.props.invoiceTemplateId,
        $sort: { orderNo: 1 }
      }
    }

    app
      .service('/api/invoice/template/item')
      .find(params)
      .then(itemRes => {
        if (itemRes && itemRes.data) {
          this.data.items = itemRes.data

          const vatInfo = calculate.calculateVatFromItems(this.data.items)
          this.data.invoice.vats = vatInfo.vats || []
        }
        callback(null)
      })
      .catch(itemErr => {
        app.debug(
          'PageInvoiceTemplateView: _getDataInvoiceItems itemErr',
          itemErr
        )
        callback(itemErr)
      })
  }

  _getVatSelectOptions (callback) {
    const address = this.data.invoice.contactAddress
    if (address && address.state) {
      const params = {
        query: {
          state: address.state
        }
      }

      app
        .service('/api/taxrate')
        .find(params)
        .then(taxRateRes => {
          this.data.taxRateVatOptions = []

          const taxRate = taxRateRes.data[0]
          if (taxRate && taxRate.rates && taxRate.rates.length > 0) {
            taxRate.rates.forEach(rate => {
              const vatOption = {
                label: rate.title,
                value: rate.percentage,
                editable: false,
                isService: rate.isService,
                isProduct: rate.isProduct
              }

              this.data.taxRateVatOptions.push(vatOption)
            })
          }

          callback(null)
        })
        .catch(taxRateErr => {
          app.debug(
            'PageEstimateView: _getVatSelectOptions taxRateErr',
            taxRateErr
          )
          callback(taxRateErr)
        })
    } else {
      callback(null)
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    this._setDataLoaded()

    if (err) {
      app.debug('PageInvoiceTemplateView: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this._refresh()
    } else {
      app.debug('PageInvoiceView: _onDataReceived [done]')
      this.data.budget = this.data.invoice.budget
      if (!this.data.budget) {
        this.data.budget = InvoiceUtil.createEmptyBudget()
      }

      if (this.data.invoice) {
        this._setFABButtonVisible(true)
      }

      const invoice = this.data.invoice
      if (invoice && invoice.contact) {
        if (
          invoice.contactAddress === undefined ||
          (invoice.contactAddress !== undefined &&
            (!invoice.contactAddress.street ||
              !invoice.contactAddress.city ||
              !invoice.contactAddress.postcode))
        ) {
          const contObj = {
            contactName: invoice.contact.company,
            address: invoice.contactAddress,
            vatNo: invoice.contact.vatNo,
            contactPersonOptions: this._getContactPersonOptions(invoice.contact)
          }

          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.show(contObj, true)
          }

          this._setFABButtonVisible(false)
        }
      }

      this._refresh()
    }
  }

  /* Private functions */
  _renderAddItem () {
    if (this.data.invoice?.status !== 'Draft') {
      return null
    }

    return (
      <PurchaseOrderAddItem
        ref={this._references.invoiceItemAdd}
        onClose={e => this._onFABInvoiceViewAddClose(e)}
        onIntroAdd={e => this._onIntroAdd(e)}
        onAddTermsAndCondition={e => this._onAddTermsAndCondition(e)}
      />
    )
  }

  _onFABInvoiceViewAddClose () {
    this._hideCloseFABButton()
  }

  onAdd () {
    this.setState({ bShowClose: true })
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.show()
    }
  }

  onFABClose () {
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }
    this.setState({ bShowClose: false })
  }

  _onIntroAdd (ev) {
    ev.preventDefault()

    if (this.data.invoice.introText === null) {
      this.data.invoice.introText = ''
    }

    this.setState({ bShowClose: false })
    if (this._references.invoiceIntro.current) {
      this._references.invoiceIntro.current.show(true)
    }

    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }
  }

  _onAddActivity (type, ev) {
    ev.preventDefault()
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }

    if (this._references.invoiceViewContent.current) {
      this._references.invoiceViewContent.current.onAddActivity(type)
    }
    this.setState({ bShowClose: false })
  }

  _onSubmitInvoiceEdit (invoiceObj) {
    this.onSubmitInvoiceEdit('/api/invoice/template', invoiceObj)
  }

  _onDeleteInvoice () {
    this.onDeleteInvoice('/api/invoice/template', 'invoice-template')
  }

  _onSubmitAddressInvoice (updateObj) {
    const invoice = this.data.invoice
    const contactAddresses = []
    let bUpdateExistingCont = false

    if (invoice.contactAddress !== undefined) {
      invoice.contact.addresses.map(address => {
        if (address.type === invoice.contactAddress.type) {
          bUpdateExistingCont = true
          address.street = updateObj.address.street
            ? updateObj.address.street
            : address.street
          address.postcode = updateObj.address.postcode
            ? updateObj.address.postcode
            : address.postcode
          address.city = updateObj.address.city
            ? updateObj.address.city
            : address.city
          address.state = updateObj.address.state
            ? updateObj.address.state
            : address.state
          address.country = updateObj.address.country
            ? updateObj.address.country
            : address.country
          address.type = address.type ? address.type : 'Invoice'
        }
        contactAddresses.push(address)
      })
    }

    const address = {
      street: updateObj.address.street,
      postcode: updateObj.address.postcode,
      city: updateObj.address.city,
      state: updateObj.address.state,
      country: updateObj.address.country,
      type: updateObj.address.type ? updateObj.address.type : 'Invoice',
      streetNumber: updateObj.address.streetNumber
    }

    const contObj = {
      company: updateObj.company,
      addresses:
        bUpdateExistingCont && contactAddresses && contactAddresses.length > 0
          ? contactAddresses
          : [address],
      vatNo: updateObj.vatNo
    }

    if (updateObj.contactPersons && updateObj.contactPersons.length > 0) {
      contObj.contactPersons = updateObj.contactPersons
    }

    async.series(
      [
        done => {
          this._updateContactAddresses(contObj, done)
        },
        done => {
          this._updateInvoiceContact('/api/invoice/template', updateObj, done)
        }
      ],
      (err, _res) => {
        if (err) {
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.showError()
          }
          app.debug('PageInvoiceTemplateView: _onSubmitAddressInvoice err', err)
        } else {
          if (this._references.refDialogInvoiceAddress.current) {
            this._references.refDialogInvoiceAddress.current.hide()
          }
        }
      }
    )
  }

  _onSubmitMail (mailObj) {
    app.debug('PageInvoiceTemplateView: _onSubmitMail [Start]')
    const updateObj = {
      contactPerson: mailObj.contactPerson,
      contactAddress: mailObj.address,
      referenceNo: mailObj.referenceNo,
      mailSetting: {
        toEmails: mailObj.toEmails
      }
    }

    /* let params = { query: { $client: { } } };
    if (mailObj.files) {
      params.query.$client = {
        files: mailObj.files
      };

      // Patch template with newly updated files
      if (mailObj.files.length > 0) {
        updateObj.mailSetting.files = updateObj.mailSetting.files.concat(mailObj.files);
      }
    }

    const updatedFiles = [];
    updateObj.mailSetting.files.map((file) => {
      updatedFiles.push({
        fileName: file.fileName,
        fileDisplayName: file.fileDisplayName
      });
    });
    updateObj.mailSetting.files = updatedFiles; */

    app
      .service('/api/invoice/template')
      .patch(this.data.invoice.id, updateObj, {})
      .then(_result => {
        if (this._references.refdialogMailSetting.current) {
          this._references.refdialogMailSetting.current.hide()
        }
      })
      .catch(err => {
        app.debug('PageInvoiceView: _onSubmitMail err', err)
      })
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.invoiceTemplatePatched = this._eventReload.bind(
      this,
      'Invoice Template',
      'Patched'
    )

    const invoiceTemplateService = app.service('/api/invoice/template')
    invoiceTemplateService.on(
      'patched',
      this._eventHandlers.invoiceTemplatePatched
    )
  }

  _eventReload (objectName, eventName, eventData) {
    if (this._canRealTimeReload() && eventfilters.teamFilter(eventData)) {
      app.debug(
        `-- Event - PageInvoiceTemplateView - ${objectName} - ${eventName} --`
      )
      this._reloadData()
    }
  }

  _releaseEvents () {
    const invoiceTemplateService = app.service('/api/invoice/template')
    invoiceTemplateService.off(
      'patched',
      this._eventHandlers.invoiceTemplatePatched
    )

    this._eventHandlers.invoiceTemplatePatched = null
  }

  _getDownloadUrl () {
    if (this.data.invoice) {
      return `/invoice/template/preview/${this.data.invoice.teamId}/${app.loggedInId}/${this.data.invoice.id}/draft.pdf`
    }

    return ''
  }

  /* Header Functions - START */
  renderHeader () {
    const { invoice } = this.data
    const isQuickbookConnected = app.isQuickbookConnected()

    if (!invoice) {
      return null
    }

    const isActive = invoice.isActive !== undefined && invoice.isActive
    const isCompleted = invoice.isCompleted || invoice.isCanceled

    const rightActions = []

    const actions = []

    if (!isCompleted) {
      actions.push({
        ident: 'mail',
        icon: 'edit',
        tooltip: 'invoicetemplate.view.mailsetting',
        tooltipPosition: 'bottom',
        onClick: this._onMailSetting.bind(this)
      })
    }

    if (!isActive) {
      rightActions.push({
        ident: 'time',
        icon: 'recurring',
        tooltip: 'invoice.view.tipEditDetails',
        tooltipPosition: 'bottomright',
        size: 'big',
        type: 'success',
        onClick: this._onEditTemplate.bind(this, invoice)
      })

      if (!isQuickbookConnected) {
        actions.push({
          ident: 'download',
          icon: 'download-solid',
          tooltip: 'invoicetemplate.view.tipDownload',
          tooltipPosition: 'bottom',
          href: this._getDownloadUrl(),
          target: '_blank'
        })
      }
    }

    if (!isActive) {
      rightActions.push({
        ident: 'start',
        icon: 'play',
        tooltip: 'invoicetemplate.view.start',
        tooltipPosition: 'bottomright',
        size: 'big',
        type: 'success',
        title: 'invoicetemplate.view.start',
        onClick: this._onStart.bind(this)
      })
    }

    if (isActive && !isCompleted) {
      rightActions.push({
        ident: 'delete',
        icon: 'x',
        tooltip: 'invoicetemplate.view.delete',
        tooltipPosition: 'bottomright',
        size: 'big',
        iconSize: '20',
        type: 'error',
        onClick: this._onComplete.bind(this),
        hasConfirm: true,
        confirmTitle: 'estimate.view.msgDecline'
      })
    }

    const statInfos = [
      {
        title: 'invoicetemplate.view.labelRepetitiveInvoices',
        value:
          `${invoice.noFinalized}/${invoice.noTotal} (` +
          `${IntlUtil.convertMessage(
            'invoicetemplate.view.headerLabel' + invoice.interval
          )})`
      },
      {
        title: 'invoicetemplate.view.labelEerstVolgende',
        value: invoice.nextRecurringDate
          ? DateUtil.getDisplayDate(invoice.nextRecurringDate)
          : '-'
      },
      {
        title: 'invoicetemplate.view.labelLastInvoice',
        value: invoice.lastRecurringDate
          ? DateUtil.getDisplayDate(invoice.lastRecurringDate)
          : '-'
      },
      {
        title: 'invoicetemplate.view.labelInvoiced',
        value: currency.formatSymbol(invoice.totalInvoiced || 0)
      },
      {
        title: 'invoicetemplate.view.labelTypeInvoice',
        value: invoice.autoMail
          ? `${IntlUtil.convertMessage(
              'invoicetemplate.view.headerLabelAutomatic'
            )}`
          : `${IntlUtil.convertMessage(
              'invoicetemplate.view.headerLabelManual'
            )}`
      }
    ]

    return (
      <PageHeader
        title={invoice.project ? invoice.project.title : ''}
        subtitle={invoice.contact ? invoice.contact.company : ''}
        icon={<InvoicesIcon width={25} />}
        statInfos={statInfos}
        actions={actions}
        rightActions={rightActions}
        alignStatInfos='bottom'
      />
    )
  }
  /* Header Functions - END */
}

export default PageInvoiceTemplateView
